var entryContent = document.querySelector('.entry-content');
if (entryContent && entryContent.innerHTML.trim() === '') {
	entryContent.style.display = 'none';
}

const lang = document.documentElement.lang;

const headingTranslations = {
	'nl-NL': 'Waar ben je naar op zoek?',
	'en-US': 'What are you looking for?',
	'de-DE': 'Wonach suchen Sie?'
};

const heading = document.querySelector('.js-search-heading');

if (heading) {
	heading.textContent =
		headingTranslations[lang] || headingTranslations['en-US'];
}

document.addEventListener('DOMContentLoaded', function () {
	const tabLinks = document.querySelectorAll('.tab-link');
	const tabItems = document.querySelectorAll('.tab-item');
	const tabPanes = document.querySelectorAll('.tab-pane');

	tabLinks.forEach((link, index) => {
		link.addEventListener('click', function (e) {
			e.preventDefault();

			// Remove active class from all tabs and stop all videos
			tabItems.forEach(item => item.classList.remove('active'));
			tabPanes.forEach(pane => {
				pane.classList.remove('active');

				// Pause any videos inside hidden tab
				const video = pane.querySelector('video');
				if (video) {
					video.pause();
					video.currentTime = 0; // Optional: reset playback
				}
			});

			// Activate clicked tab and play its video if present
			tabItems[index].classList.add('active');
			tabPanes[index].classList.add('active');

			const activePane = tabPanes[index];
			const activeVideo = activePane.querySelector('video');
			if (activeVideo) {
				activeVideo.play();
			}
		});
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const htmlLang = document.documentElement.lang; // e.g. "nl-NL", "de-DE", "en-US"
	const newsLink = document.querySelector('.breadcrumbs a[href="/news"]');

	if (!newsLink) return;

	if (htmlLang.startsWith('nl')) {
		newsLink.href = '/nl/nieuws';
		newsLink.textContent = 'Nieuws';
	} else if (htmlLang.startsWith('de')) {
		newsLink.href = '/de/nachrichten';
		newsLink.textContent = 'Nachrichten';
	} else {
		newsLink.href = '/news';
		newsLink.textContent = 'News';
	}
});

document.addEventListener("DOMContentLoaded", function () {
	const wrappers = Array.from(document.querySelectorAll(".Partner.Overview"));

	wrappers.forEach((wrapper) => {
		const track = wrapper.querySelector(".horizontal_inner");
		if (!wrapper || !track) return;

		let direction = -1; // -1 = left, 1 = right
		let position = 0;

		const wrapperWidth = wrapper.offsetWidth;
		const trackWidth = track.scrollWidth;

		const maxScroll = Math.max(trackWidth - wrapperWidth + 500, 0); // safety check


		function animateScroll() {
			position += direction * 0.4;

			if (position <= -maxScroll) {
				position = -maxScroll;
				direction = 1;
			} else if (position >= 0) {
				position = 0;
				direction = -1;
			}

			track.style.transform = `translateX(${position}px)`;
			requestAnimationFrame(animateScroll);
		}

		animateScroll();
	});
});

const header = document.querySelector('.site-header');
if (header) {
	const searchModal = document.querySelector('.search-modal');
	if (searchModal) {
		header?.querySelector(".search")?.addEventListener("click", function (e) {
			e.preventDefault();
			if (searchModal) {
				searchModal.classList.toggle('active');
				document.body.classList.toggle('search-active');
			}
		});
	}
}

(function () {
	const ITEM_SELECTOR   = ".team-item";
	const COUNT_SELECTOR  = ".showing-count";
	const BUTTON_SELECTOR = ".show-more";
	const NAV_SELECTOR    = ".team-nav"; // your existing nav container
	const VISIBLE_COUNT   = 8;

	// Delegated click listener (survives AJAX reload)
	document.addEventListener("click", function (e) {
		const btn = e.target.closest(BUTTON_SELECTOR);
		if (!btn) return;

		const container = findItemsContainer();
		if (!container) return;

		const items   = container.querySelectorAll(ITEM_SELECTOR);
		const countEl = document.querySelector(COUNT_SELECTOR);

		// Show all items
		items.forEach(el => el.classList.remove("hidden"));
		if (countEl) countEl.textContent = `${items.length} resultaten van de ${items.length}`;

		// Hide button
		btn.style.display = "none";
	});

	function initTeamList() {
		const container = findItemsContainer();
		if (!container) return;

		const items   = Array.from(container.querySelectorAll(ITEM_SELECTOR));
		const countEl = document.querySelector(COUNT_SELECTOR);
		const button  = document.querySelector(BUTTON_SELECTOR);
		const nav     = document.querySelector(NAV_SELECTOR);
		const total   = items.length;

		// Hide extra items
		items.forEach((item, idx) => {
			if (idx < VISIBLE_COUNT) item.classList.remove("hidden");
			else item.classList.add("hidden");
		});

		// Update count
		if (countEl) {
			const shown = Math.min(VISIBLE_COUNT, total);
			countEl.textContent = `${shown} resultaten van de ${total}`;
		}

		// Update button visibility
		if (button && nav) {
			if (total > VISIBLE_COUNT) {
				button.style.display = "";
				nav.style.display = ""; // show nav
			} else {
				button.style.display = "none";
				nav.style.display = total > 0 ? "" : "none"; // hide whole nav if no results
			}
		}
	}

	function findItemsContainer() {
		// Finds the parent container that holds the .team-item elements
		const first = document.querySelector(ITEM_SELECTOR);
		return first ? first.parentElement : null;
	}

	// Initial load
	document.addEventListener("DOMContentLoaded", initTeamList);

	// Re-run after AJAX filtering (Search & Filter Pro)
	(function ($) {
		if (!$) return;
		$(document).on("sf:ajaxfinish", ".searchandfilter", function () {
			setTimeout(initTeamList, 0);
			setTimeout(initTeamList, 50);
		});
	})(window.jQuery);
})();

